<template>
  <span>
    <span><slot></slot></span> &nbsp;<i class="las la-copy" @click.stop.prevent="copy" style="font-size: 1.3em"></i> <q-tooltip no-parent-event v-model="tt">copied</q-tooltip>
  </span>
</template>

<script>

export default {
  name: 'CopySpan',
  props: [],
  data () {
    return {
      tt: false
    }
  },
  methods: {
    copy (event) {
      var vm = this
      var el = event.target.previousElementSibling
      if (!el) { return }
      var text = el.innerHTML || ''
      text = text.trim()
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
        this.tt = true
        setTimeout(() => { vm.tt = false }, 2000)
      } else {
        alert('Cannot copy to clipboard: ' + text)
      }
    }
  }
}
</script>
